import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import ChartTypes from "@/components/ChartTypes.tsx";
import DashboardDataGenerator from "../../DashboardDataGenerator";
import Reading from "./Reading";
import ReadingFeedbackMain from "./ReadingFeedbackMain";
import { updateTeacherScoring } from "@/service/DashboardBackend";
import TestletStatus from "./TestletStatus";

@Component
export default class StudentDashboard extends Vue {
  private data: any = {};
  private processedData: any = {};
  private completionData: any = {};
  private dbLayout: any;

  created() {
    this.dbLayout = this.getDashboardLayout();
  }

  private getAllData() {
    // all state should be loaded by now
    this.data = this.$store.getters.studentDashboard.bala.timepoint1;
    this.completionData = this.data.completionStatus;
    let results = this.data.results;
    let averagesData = this.data.averages;

    if (results == {} || results === undefined) {
      // not enough data for dashboard
      return false;
    }

    results &&
      Object.keys(results).forEach(key => {
        let data = results[key];
        this.processedData[key] = {
          percent: data["proportion"] * 100,
          mean: averagesData[key]
        };
      });

    // update dashboard layout if necessary
    this.dbLayout = this.getDashboardLayout();

    // alert(JSON.stringify(this.processedData))
    return true;
  }

  private stateLoaded() {
    return this.$store.getters.studentDashboard.bala.timepoint1Loaded;
  }

  private dashboardUnavailable() {
    return (
      <v-container>
        <v-row>There's not enough data to generate a dashboard.</v-row>
      </v-container>
    );
  }

  private getDashboardLayout() {
    return this.$vuetify.breakpoint.lg
      ? [
          { x: 0, y: 0, w: 8, h: 11, i: "0" },
          { x: 8, y: 0, w: 4, h: 5, i: "1" },
          { x: 8, y: 5, w: 4, h: 6, i: "2" }
        ]
      : [
          { x: 0, y: 0, w: 12, h: 11, i: "0" },
          { x: 0, y: 11, w: 6, h: 5, i: "1" },
          { x: 6, y: 11, w: 6, h: 6, i: "2" }
        ];
  }

  render(h: CreateElement) {
    return (
      (this.stateLoaded() && this.getAllData() && (
        <v-container>
          <grid-layout
            layout={this.dbLayout}
            col-num={12}
            row-height={30}
            is-draggable={false}
            is-resizable={false}
            is-mirrored={false}
            vertical-compact={true}
            margin={[24, 24]}
            use-css-transforms={false}
            // cols={{lg: 12, md: 8, sm: 12, xs: 12, xxs: 12}}
            ref="gridLayout"
          >
            <grid-item
              x={this.dbLayout[0].x}
              y={this.dbLayout[0].y}
              w={this.dbLayout[0].w}
              h={this.dbLayout[0].h}
              i={this.dbLayout[0].i}
              key={this.dbLayout[0].i}
            >
              <Reading
                data={this.processedData}
                style={{ height: "inherit" }}
              />
            </grid-item>
            <grid-item
              x={this.dbLayout[2].x}
              y={this.dbLayout[2].y}
              w={this.dbLayout[2].w}
              h={this.dbLayout[2].h}
              i={this.dbLayout[2].i}
              key={this.dbLayout[2].i}
            >
              <ReadingFeedbackMain></ReadingFeedbackMain>
            </grid-item>
            <grid-item
              x={this.dbLayout[1].x}
              y={this.dbLayout[1].y}
              w={this.dbLayout[1].w}
              h={this.dbLayout[1].h}
              i={this.dbLayout[1].i}
              key={this.dbLayout[1].i}
            >
              <TestletStatus
                style={{ height: "inherit" }}
                data={this.completionData}
              ></TestletStatus>
            </grid-item>
          </grid-layout>
          {/* // <v-row>
          //   <v-col cols="8">
          //     <Reading data={this.processedData} />
          //   </v-col>
          //   <v-col cols="4">
          //   <v-row>
          //   <v-col style={{paddingTop: '0px'}}><TestletStatus></TestletStatus></v-col>
          //   </v-row>
          //   <v-row>
          //     <v-col style={{paddingBottom: '0px'}}>
          //     <ReadingFeedbackMain></ReadingFeedbackMain>
          //     </v-col>
          //   </v-row>
          //   </v-col>
          // </v-row> */}
        </v-container>
      )) ||
      this.dashboardUnavailable()
    );
  }
}

const component = StudentDashboard;
